import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-std-atd-settings',
  templateUrl: './std-atd-settings.component.html',
  styleUrls: ['./std-atd-settings.component.scss']
})
export class StdAtdSettingsComponent implements OnInit {
  StdAtdSetting: FormGroup;
  submitpayload: any;
  submitButton = true; 
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  BranchShow = false;
  saveDisable = false;
  updateDisable = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  Session: any;
  filteredListExam: any;
  ExamList: any;
  BranchList: any;
  filteredListBranch: any;
  emid: any;
  subjectList = []
  filteredsubjectList
  exsubjectData
  savedpayload: any;
  tableData: any;
  userPermission: any;
  UserCollege
  utp: string;
  AtdSettingCreate = true;
  AtdSettingUpdate = true;
  SubCode: string;
  Branch: any;
  // jsonData: any;
  fcCodeList: any[] = [];
  filteredListFcCode: any;
  SelectAllActive: boolean = false;
  selectedColleges: any[] = [];
  isSelectAll: boolean = false;
  commaSeparatedColleges: string;
  commaSeparatedCourses: string;
  isLoadingSubjects = false;
  isLoadingAttendance = false;
  showCgName: boolean = false;
  originalData: any[] = [];
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.isSelectAll = true
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Subject Attendance' && element.PCreate == false)
      {
          this.AtdSettingCreate = false;  
      }
      if(element.PageName == 'Subject Attendance' && element.PUpdate == false)
      {
          this.AtdSettingUpdate = false;  
      }   
     
    });
  }
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.BranchShow = false;
    this.Table = false
    this.submitButton = true;
    this.editButton = false;
    this.saveDisable = false
    this.updateDisable = false
    this.StdAtdSetting = this.fb.group({
      CgCode: new FormControl(''),
      CgName: new FormControl(''),
      CoCode: new FormControl(''),
      EmId: new FormControl(''),
      StrId: new FormControl(0),
      SessionId: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
      CoFcCode:new FormControl(''),
    });
    this.fetchSession('');
    this.fetchFacultyCode()
    this.currentDate = new Date();
  }

  getStuArrayControls() {
    return (this.StdAtdSetting.get('StuArray') as FormArray).controls;
  }

  fetchSession(id) {
    this.Session = 0
    this.spinner.show();
    const payload = {};
    this.filteredListFcCode = [];
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  onSessionChange(sessionId: any) {
    this.StdAtdSetting.patchValue({
      CoCode: null,
      CgCode: [],
      EmId: null,
      EsParentId: null,
    });

    this.CourseList = [];
    this.filteredListCourse = [];

    this.collegeList = [];
    this.filteredCollegeList = [];

    this.ExamList = [];
    this.filteredListExam = [];

    this.subjectList = [];
    this.filteredsubjectList = [];

    if (sessionId) {
    // this.fetchFacultyCode();
  }
}

  onCollegeChange(selected) {
    this.selectedColleges = selected;
}

  getCollegeData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();

    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  SetSession(data) {
    this.Session = data
  }

  onCourseChange(coCode: any) {

    this.StdAtdSetting.patchValue({
      CgCode: [],
      EmId: null,
      EsParentId: null
    });

    this.collegeList = [];
    this.filteredCollegeList = [];

    if (coCode) {
      this.getCollegeByCourse(coCode);
    }
}

  getCollegeByCourse(coCode: string) {

    this.spinner.show();
    const payload = { CoCode: coCode };

    this.umsService.getCollegeCourse(payload).subscribe({
      next: (res: any) => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = [...this.collegeList];
      } else {
        this.collegeList = [];
        this.filteredCollegeList = [];
      }
      this.getExam(coCode)
      this.spinner.hide();
    },
    error: () => {
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.spinner.hide();
    }
  });
}

  getCourse(facultyCode) {

    this.spinner.show();
    const payload = { CoFcCode: facultyCode };

    this.umsService.getCourse(payload).subscribe({
      next: (res: any) => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = [...this.CourseList];
      } else {
        this.CourseList = [];
      }
      this.spinner.hide();
    },
    error: () => {
      this.CourseList = [];
      this.spinner.hide();
    }
  });
}

  onExamChange(examId: any) {
    this.StdAtdSetting.patchValue({
    EsParentId: null,
  });

    this.subjectList = [];

    if (examId) {
      this.subjectsList(this.emid, examId);
  }
}

  getExam(data) {
    this.Table = false;
    this.StdAtdSetting.controls['EmId'].setValue('');
    this.StdAtdSetting.controls['StrId'].setValue('');
    this.ExamList = [];
    this.BranchList = [];
    this.BranchShow = false;
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.ExamList = res.data;
        this.filteredListExam = this.ExamList.slice();
      }
      else {
        this.ExamList.data = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }

  fetchBranch(data) {
    this.emid = data;
    const payload = {};
    payload['EmId'] = data;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getExmSub(data) {
    this.StdAtdSetting.controls['StrId'].setValue('');
    this.BranchList = [];
    this.emid = 0;
    this.Table = false;
    if (data.EmStreams == "Y") {
      this.BranchShow = true;
      this.StdAtdSetting.controls['StrId'].setValue(0)
      this.fetchBranch(data.EmId);
    }

    else {
      this.StdAtdSetting.controls['StrId'].setValue(0)
      this.BranchShow = false;
      this.Branch = 0

    }
    this.subjectsList(data.EmId, 0)
  }

  ShowTable(){
    this.getAttendance(this.emid, this.Branch)
  }

  getAttendance(emid, strid) {

  if (this.isLoadingAttendance) return;
  this.isLoadingAttendance = true;

  this.savedpayload = this.StdAtdSetting.value;
  this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
  this.StuArray.clear();

  const payload = {
    CgCode: Array.isArray(this.savedpayload.CgCode)
      ? this.savedpayload.CgCode.join(',')
      : this.savedpayload.CgCode,
    CoCode: this.savedpayload.CoCode,
    EmId: this.savedpayload.EmId,
    StrId: this.savedpayload.StrId,
    SessionId: this.savedpayload.SessionId,
    EsParentId: this.savedpayload.EsParentId
  };

  this.umsService.getStuAtdSet(payload).subscribe(res => {

    this.isLoadingAttendance = false;

    if (res.status) {
      this.showCgName = true;  
      this.Table = true;
  this.loadStudentAttendanceTable(res.data);

      const isAllNull = res.data.every(item => item.Attendance === null);
      const hasNumericalValue = res.data.some(item => typeof item.Attendance === 'number');

      this.SaveBtn = isAllNull;
      this.UpdateBtn = !isAllNull && hasNumericalValue;
    } else {
      this.subjects();
      this.showCgName = false;
    }
  });
}

  subjects() {

  if (this.isLoadingSubjects) {
    return;
  }

  this.isLoadingSubjects = true;
  this.SaveBtn = true;
  this.UpdateBtn = false;
  this.savedpayload = this.StdAtdSetting.value;
  this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
  this.StuArray.clear();
  this.tableData = [];

  const payload = { EsId: this.savedpayload.EsParentId };

  this.umsService.getThHead(payload).subscribe(res => {

    this.isLoadingSubjects = false;

    if (res.status) {
      this.Table = true;
      this.tableData = res.data;

      this.tableData.forEach((element, i) => {
        this.StuArray.push(
          this.fb.group({
            SrNo: i + 1,
            EsCode: element.EsCode,
            EsName: element.EsName,
            CgName: element.CgName,
            EsId: element.EsId,
            Attendance: ['', [Validators.required]],
            AttSetId: '',
            CoFcCode: element.CoFcCode
          })
        );
      });

    } else {
      this.Table = false;
      this.SaveBtn = false;
      this.UpdateBtn = false;
    }

  }, err => {
    this.isLoadingSubjects = false;
    this.Table = false;
  });
}

  getBrSub(data) {
    // this.getAttendance(this.emid, data);
    this.subjectsList(this.emid, data)
    this.Branch = data
  }

  addNewRow() {
    const creds = this.StdAtdSetting.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        EsCode: new FormControl(''),
        EsName: new FormControl(''),
        CgName: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.max(100),, Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl(''),
        AttSetId: new FormControl(''),
        CoFcCode:new FormControl(''),
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.StdAtdSetting.get('StuArray') as FormArray;
    if(tempData > 100){
        taskListArrays.controls[i].get('Attendance').setErrors({ PercentError: true });
      if(this.SaveBtn == true){
        this.saveDisable = true
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = true
      }
    }
    else{
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if(this.SaveBtn == true){
        this.saveDisable = false
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = false
      }
    }

    
    if (tempData >= 75) {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if (tempData < 75) {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }
    else if (tempData == '') {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }

    if (/[^0-9]/.test(tempData)) {
      taskListArrays.controls[i].get('Attendance').setErrors({ NonNumericError: true });
      if(this.SaveBtn == true){
        this.saveDisable = true
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = true
      }
    }
    else{
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if(this.SaveBtn == true){
        this.saveDisable = false
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = false
      }
    }

    
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save(){
    if (this.StdAtdSetting.invalid) {
      this.StdAtdSetting.get('CoCode').markAsTouched();
      this.StdAtdSetting.get('SessionId').markAsTouched();
      this.StdAtdSetting.get('EmId').markAsTouched();
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.SaveAtd()
      return
    }
  }

  SaveAtd() {
    this.spinner.show();
    this.submitpayload = this.StdAtdSetting.value;
    this.StdAtdSetting.controls.StuArray as FormArray;
    this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionId'] = this.submitpayload['SessionId'];
        payload['CgCode'] = Array.isArray(this.submitpayload.CgCode)
        ? this.submitpayload.CgCode.join(',')
        : this.submitpayload.CgCode;

        payload['CoCode'] = this.submitpayload['CoCode'];
        payload['CoFcCode'] = this.submitpayload['CoFcCode'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['StrId'] = this.submitpayload['StrId'];
        payload['EsParentId'] = this.submitpayload['EsParentId']
        payload['Attendance'] = parseInt(element.Attendance);
        payload['EsId'] = parseInt(element.EsId);
        payload['EsName'] = element.EsName;
        payload['EsCode'] = element.EsCode;
        this.umsService.saveStuAtdSet(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });
      }
    });
  }

  update(){
    if (this.StdAtdSetting.invalid) {
      this.StdAtdSetting.get('CoCode').markAsTouched();
      this.StdAtdSetting.get('SessionId').markAsTouched();
      this.StdAtdSetting.get('EmId').markAsTouched();
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.updateAtd()
      return
    }
  }

  onAttendanceChange(index: number) {
  const row = this.StuArray.at(index) as FormGroup;
  row.patchValue({ isModified: true });
}

  loadStudentAttendanceTable(data: any[]) {
  this.StuArray = this.StdAtdSetting.get("StuArray") as FormArray;
  this.StuArray.clear();

  data.forEach((row, index) => {
    const rowWithSrNo = { ...row, SrNo: index + 1 };
    this.StuArray.push(this.createStudentRow(rowWithSrNo));
  });
}



  createStudentRow(element): FormGroup {
  return this.fb.group({
    SrNo: element.SrNo,
    EsCode: element.EsCode,
    EsName: element.EsName,
    CgName: element.CgName,
    EsId: element.EsId,
    AttSetId: element.AttSetId,
    CoFcCode: element.CoFcCode,
    Attendance: element.Attendance,

    isModified: false
  });
}

  updateAtd() {
  this.spinner.show();

  this.submitpayload = this.StdAtdSetting.value;
  this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;

  const modifiedRows = this.StuArray.value.filter(r => r.isModified);

  if (modifiedRows.length === 0) {
    this.spinner.hide();
    this.modalPopupService.openPopup(AlertBoxComponent, {
      message: "No changes to update",
      title: "Information",
      icon: "fas fa-info-circle"
    });
    return;
  }

  let completedCalls = 0;

  modifiedRows.forEach(element => {
    const payload = {
      SessionId: this.submitpayload.SessionId,
      CgCode: Array.isArray(this.submitpayload.CgCode)
        ? this.submitpayload.CgCode.join(',')
        : this.submitpayload.CgCode,
      CoCode: this.submitpayload.CoCode,
      CoFcCode: this.submitpayload.CoFcCode,
      EmId: this.submitpayload.EmId,
      StrId: this.submitpayload.StrId,
      EsParentId: this.submitpayload.EsParentId,
      Attendance: parseInt(element.Attendance),
      AttSetId: parseInt(element.AttSetId),
      EsId: parseInt(element.EsId),
      EsName: element.EsName,
      EsCode: element.EsCode
    };

    const apiCall = isNaN(payload.AttSetId)
      ? this.umsService.saveStuAtdSet(payload)
      : this.umsService.updateStuAtdSet(payload);

    apiCall.subscribe(
      (res) => {
        completedCalls++;

        this.modalPopupService.openPopup(AlertBoxComponent, {
          message: res.status ? "Updated Successfully" : res.message,
          title: res.status ? "Information" : "Alert",
          icon: res.status ? "fas fa-check" : "fas fa-close"
        });

        if (completedCalls === modifiedRows.length) {
          this.spinner.hide();
          setTimeout(() => {
          this.getAttendance(this.submitpayload.EmId, this.submitpayload.StrId);
          }, 50);
        }
      },
      (error: HttpErrorResponse) => {
        completedCalls++;
        this.modalPopupService.openPopup(AlertBoxComponent, {
          message: error.error.message,
          title: "Alert",
          icon: "fas fa-close"
        });

        if (completedCalls === modifiedRows.length) {
          this.spinner.hide();
          setTimeout(() => {
          this.getAttendance(this.submitpayload.EmId, this.submitpayload.StrId);
          }, 50);
        }
      }
    );
  });
}

  getid(value){
    let id = value.controls.EsCode.value;
    return id;
  }

  subjectsList(EmId, StrId) {
    this.SubCode = ''
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = StrId;
    payload['EsType'] = 'S'
    this.umsService.getSubjectList(payload).subscribe(res => {
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
    });
  }

  fetchFacultyCode() {
  this.umsService.getFaculty({}).subscribe(res => {
    if (res.status) {
      this.fcCodeList = res.data || [];
      this.filteredListFcCode = [...this.fcCodeList];  
    }
  });
}

  onFacultyChange(fcCode: any) {
  this.StdAtdSetting.patchValue({
    CoCode: null,
    CgCode: [],
    EmId: null,
    EsParentId: null,
  });

  this.CourseList = [];
  this.collegeList = [];

  if (fcCode) {
    this.getCourse(fcCode);
  }
}

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['CutOffDateAllClg'] == 1){
        }
        else if(arrActiveFlow[0]['CutOffDateAllClg'] == 0){
          this.getCollegeData();
        }

      }
      else{
        this.spinner.hide()
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }

  onSelectAllClick() {
  const allCodes = this.filteredCollegeList.map(x => x.CgCode);

  if (this.isAllCollegesSelected()) {
    this.selectedColleges = [];
  } else {
    this.selectedColleges = allCodes;
  }

  this.StdAtdSetting.controls['CgCode'].setValue(this.selectedColleges, { emitEvent: false });

  this.commaSeparatedColleges = this.selectedColleges.join(',');
  this.onCollegeSelect({ value: this.selectedColleges });
}

  onCollegeSelect(event: any) {

  let selected = event.value.filter(v => v !== 'selectAll');

  this.selectedColleges = selected;

  this.StdAtdSetting.get('CgCode').setValue(selected, { emitEvent: false });

  this.commaSeparatedColleges = this.selectedColleges.join(',');
  this.StdAtdSetting.patchValue({
    EmId: null,
    EsParentId: null
  });
  this.ExamList = [];
  this.filteredListExam = [];
  this.subjectList = [];
  this.filteredsubjectList = [];
  this.Table = false;
  if (selected.length > 0 && this.StdAtdSetting.get('CoCode').value) {
    this.getExam(this.StdAtdSetting.get('CoCode').value);
  }
}

  isAllCollegesSelected(): boolean {
  return(
    this.filteredCollegeList.length > 0 &&
    this.selectedColleges.length === this.filteredCollegeList.length
  );
}
 
}
